/** @jsx jsx **/
import { jsx } from "@emotion/react";
import { useContext } from "react";

import { Icon } from "@myrealtrip/design-system";

import { snsListInfo } from "@constants";
import { DetermineMobileContext } from "@modules";

import * as styles from "./snslist.style";

export default function SNSList() {
  const isMobile = useContext(DetermineMobileContext);

  return (
    <div css={styles.rowSNSList}>
      <ul css={styles.SNSList}>
        {snsListInfo.map((value, index) => (
          <li key={value.link + index}>
            <a href={value.link} target="_blank" rel="noopener noreferrer">
              <Icon name={isMobile ? value.icon.mo : value.icon.pc} />
            </a>
          </li>
        ))}
      </ul>
      {!isMobile && (
        <ul css={styles.storeList}>
          <li>
            <a
              href="https://apps.apple.com/app/id1141745032"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon name="ic_appstore_20x20_gray_400" />
            </a>
          </li>
          <li>
            <a
              href="https://play.google.com/store/apps/details?id=com.mrt.ducati"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon name="ic_googleplay_20x20_gray_400" />
            </a>
          </li>
        </ul>
      )}
    </div>
  );
}
